import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const AsyncAutomationPanelView = lazyForPaint(() =>
	import(/* webpackChunkName: "async-automation-discovery-panel" */ './ui/index').then(
		({ AutomationDiscoveryContainer }) => AutomationDiscoveryContainer,
	),
);
